// Wave 3 — Standard boilerplate Terms of Service (Owner-editable via /admin/website/content).
import React from "react";
import PublicShell, { usePublicContent } from "../../../components/public/PublicShell";

export default function Terms() {
  const c = usePublicContent();
  const body = c.legal_terms_body;
  return (
    <PublicShell>
      <section className="erf-public-section" data-testid="terms-body">
        <div className="erf-public-container" style={{ maxWidth: 820 }}>
          <div className="erf-public-eyebrow">Legal</div>
          <h1 style={{ marginTop: 12 }}>Terms of Service</h1>
          {body ? (
            <div style={{ fontSize: 16, lineHeight: 1.7, color: "var(--exec-body)", whiteSpace: "pre-wrap" }}>{body}</div>
          ) : (
            <div style={{ fontSize: 16, lineHeight: 1.7, color: "var(--exec-body)" }}>
              <p>These Terms of Service ("Terms") govern your use of the website and services provided by ERF ENTERPRISES LLC ("ERF"). By accessing this site or engaging our services, you agree to these Terms.</p>
              <h3 style={{ marginTop: 32 }}>Services</h3>
              <p>ERF provides general contracting services on a per-project basis under a signed written contract. Website content is informational only and does not constitute a binding offer.</p>
              <h3 style={{ marginTop: 32 }}>Quotes &amp; estimates</h3>
              <p>All quotes and estimates provided via this site or in initial consultation are non-binding until formalized in a signed contract.</p>
              <h3 style={{ marginTop: 32 }}>Intellectual property</h3>
              <p>All content on this site — text, imagery, logos — is the property of ERF ENTERPRISES LLC and may not be reused without written permission.</p>
              <h3 style={{ marginTop: 32 }}>Limitation of liability</h3>
              <p>ERF's total liability for any claim arising from this site is limited to the amount paid, if any, for use of this site. All construction services are governed exclusively by the signed project contract.</p>
              <h3 style={{ marginTop: 32 }}>Contact</h3>
              <p>Questions about these Terms may be directed to ERF via the contact page.</p>
              <p style={{ marginTop: 40, fontSize: 12, color: "var(--exec-body)", fontStyle: "italic" }}>
                This is a standard-form Terms of Service placeholder. Edwin may replace this text with a jurisdiction-specific version via <code>/admin/website/content</code> key <code>legal_terms_body</code>.
              </p>
            </div>
          )}
        </div>
      </section>
    </PublicShell>
  );
}
